import { useState, useContext } from 'react';

import endpoints from '../../../../../../api/endpoints';
import { DialogError } from '../../../../../common/business-error';
import { handleResponseError } from '../../../../../../api/handleResponseError';
import { ToastNotificationContext } from '../../../../../common/toast-notification';
import { addParams, fetchWithTokenRefresh } from '../../../../../../api/fetchWithTokenRefresh';

import { getRejectAnOrderBusinessError } from '../businessErrors';

interface RejectAnOrderProps {
  creditOrderId: string;
  onSuccess: () => void;
}

export const useRejectPendingWalletCreditOrder = () => {
  const { openToast } = useContext(ToastNotificationContext);
  const [rejectAnOrderLoading, setLoading] = useState<boolean>(false);
  const [rejectAnOrderError, setError] = useState<DialogError>(null);

  const handleRejectAnOrder = async ({ creditOrderId, onSuccess }: RejectAnOrderProps) => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetchWithTokenRefresh(
        endpoints.walletCreditExternalTransferReject(creditOrderId),
        addParams('PUT', {})
      );

      if (response.status !== 200) {
        await handleResponseError(response);
      }

      openToast({
        message: 'Credit order successfully rejected',
        severity: 'success'
      });

      onSuccess();
      setLoading(false);
    } catch (e) {
      const { message, severity } = getRejectAnOrderBusinessError(e);

      setError({ message, severity });
      setLoading(false);
    }
  };

  return { rejectAnOrderLoading, rejectAnOrderError, handleRejectAnOrder };
};
